import i from './tariff-simulation-release.container';

export default i;
